import React, { useEffect, useState } from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const purchases = [['Andrea V.', 'Milano', 'PALLAVOLO PRONTA — Pacchetto Completo'], ['Marco S.', 'Bologna', 'PALLAVOLO PRONTA — Pacchetto Completo'], ['Lucia F.', 'Roma', 'PALLAVOLO PRONTA — Pacchetto Completo'], ['Giulia R.', 'Torino', 'PALLAVOLO PRONTA — Pacchetto Completo']];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [purchase, setPurchase] = useState(purchases[0]);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let cycleTimer: number;
    const show = () => {
      setPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        cycleTimer = window.setTimeout(show, 28000 + Math.floor(Math.random() * 14000));
      }, 5000);
    };
    const initialTimer = window.setTimeout(show, 15000);
    return () => {
      window.clearTimeout(initialTimer);
      window.clearTimeout(hideTimer);
      window.clearTimeout(cycleTimer);
    };
  }, [dismissed]);
  if (dismissed) return null;
  return <aside aria-live="polite" className={`fixed bottom-4 left-4 z-50 w-[calc(100%-2rem)] max-w-sm transition-all duration-500 ${visible ? 'translate-x-0 opacity-100' : '-translate-x-[120%] opacity-0'}`} data-id="element-197">
      <div className="relative border border-emerald-950/10 bg-white p-4 pr-10 shadow-2xl" data-id="element-198">
        <button type="button" aria-label="Chiudi la notifica di acquisto" onClick={() => setDismissed(true)} className="absolute right-2 top-2 p-1 text-slate-500 hover:text-[#09281d]" data-id="element-199">
          <XIcon className="h-4 w-4" data-id="element-200" />
        </button>
        <p className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-emerald-800" data-id="element-201">
          <span className="grid h-4 w-4 place-items-center rounded-full bg-emerald-500" data-id="element-202">
            <CheckIcon className="h-3 w-3 text-white" data-id="element-203" />
          </span>
          Acquisto verificato
        </p>
        <p className="mt-3 text-sm font-semibold text-[#09281d]" data-id="element-204">
          <strong data-id="element-205">{purchase[0]}</strong> da {purchase[1]}
        </p>
        <p className="mt-1 text-xs font-medium text-slate-600" data-id="element-206">
          ha appena acquistato{' '}
          <span className="font-bold text-emerald-800" data-id="element-207">{purchase[2]}</span>
        </p>
      </div>
    </aside>;
}